import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const _socialYouTube: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 85 85'>
        <title>Youtube</title>
        <g id='Circle_Color' data-name='Circle Color'>
            <g id='YouTube'>
                <circle id='back' fill='#e52d27' cx='42.5' cy='42.5' r='42.5' />
                <path
                    id='youtube-2'
                    data-name='youtube'
                    fill='#fff'
                    d='M66.3,52a6.82,6.82,0,0,1-6.8,6.8h-34A6.82,6.82,0,0,1,18.7,52V33a6.82,6.82,0,0,1,6.8-6.8h34A6.82,6.82,0,0,1,66.3,33ZM37.58,48.34l12.87-6.66L37.58,35Z'
                />
            </g>
        </g>
    </svg>
);

const SocialYouTube = styled(_socialYouTube)``;

export default SocialYouTube;
